import { render } from "./HeroContent.vue?vue&type=template&id=9f0a167c"
import script from "./HeroContent.vue?vue&type=script&lang=js"
export * from "./HeroContent.vue?vue&type=script&lang=js"

import "./HeroContent.vue?vue&type=style&index=0&id=9f0a167c&lang=scss"

import exportComponent from "/codebuild/output/src4163787984/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__